/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import PcrRouter from './pcr'
import padVersionRouter from './pad-version';

import Login from '@/views/login.vue';

import Models from '@/views/models/index.vue';
import ModelEditor from '@/views/models/editor/index.vue';
import ModelInfo from '@/views/models/editor/info.vue';
import ModelLoading from '@/views/models/editor/loading.vue';
import ModelVRSettings from '@/views/models/editor/vr-settings.vue';
import ModelLabelManagement from '@/views/models/editor/label-management.vue';
import ModelItemManagement from '@/views/models/editor/item-management.vue';
import HouseMarking from '@/views/models/editor/house-marking.vue';
import ImageEditor from '@/views/models/editor/image-editor.vue';
import CADAlignment from '@/views/map/editor/cad-alignmet.vue';
import RoamVr from '@/views/models/editor/vr-roam.vue';
import videoUpload from '@/views/models/editor/videoUpload.vue'
import CADAlignmented from '@/views/models/editor/cad-alignmeted.vue';
import Map from '@/views/map/index.vue';
import MapEditor from '@/views/map/editor/index.vue';
import VRCompose from '@/views/map/editor/vr-compose.vue';
import DrawPath from '@/views/map/editor/draw-path.vue';
import ContactPath from '@/views/map/editor/contact-path.vue';

import ViewModel from '@/views/models/editor/view-model.vue';

import Users from '@/views/users.vue';

import ArManager from '@/views/ar-manager.vue';

import MapAlignment from '@/views/alignment/index.vue';
import AlignmentList from '@/views/alignment/list.vue';

import NotFound from '@/views/not-found.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    ...PcrRouter,
    ...padVersionRouter,
    {
      path: '/x/models',
      name: 'models',
      component: Models,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/x/models/:modelId/view',
      name: 'model-view',
      component: ViewModel,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/x/mapAlignments/:mergeId/editor',
      name: 'mapAlignment',
      component: MapAlignment,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/x/models/:modelId/editor',
      component: ModelEditor,
      meta: {
        keepAlive: false
      },
      children: [{
          path: 'info',
          component: ModelInfo,
          name: 'model-editor-info'
        },
        {
          path: 'loading',
          component: ModelLoading,
          name: 'model-editor-loading'
        },
        {
          path: 'vr-settings',
          component: ModelVRSettings,
          name: 'model-editor-vr-settings'
        },
        {
          path: 'label-management',
          component: ModelLabelManagement,
          name: 'model-editor-label-management'
        },
        {
          path: 'item-management',
          component: ModelItemManagement,
          name: 'model-editor-item-management'
        },
        {
          path: '',
          redirect: 'info'
        },
        {
          path: 'house-marking',
          component: HouseMarking,
          name: 'model-editor-house-marking'
        },
        {
          path: 'image-editor',
          component: ImageEditor,
          name: 'model-editor-image'
        },
        {
          path: 'cad-alignmeted',
          component: CADAlignmented,
          name: 'model-cad-alignmet'
        },
        {
          path: 'vr-roam',
          component: RoamVr,
          name: 'vr-roam'
        },
        {
          path: 'vr-videoUpload',
          component: videoUpload,
          name: 'vr-videoUpload'

        }

      ]
    },
    {
      path: '/x/map',
      name: 'map',
      component: Map,
      meta: {
        keepAlive: true
      }
    }, {
      path: '/x/map/:mapId/editor',
      name: 'mapEditor',
      component: MapEditor,
      children: [{
        path: 'vr-compose',
        name: 'vr-compose',
        component: VRCompose,
        meta: {
          keepAlive: true
        }
      }, {
        path: 'draw-path',
        name: 'draw-path',
        component: DrawPath,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'contact-path',
        name: 'contact-path',
        component: ContactPath
      }, {
        path: 'cad-alignmet',
        component: CADAlignment,
        name: 'map-cad-alignmet',
        meta: {
          keepAlive: false
        }
      }]
    },
    {
      path: '/x/users',
      name: 'users',
      component: Users,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/x/ar',
      name: 'ar',
      component: ArManager,
      meta: {
        keepAlive: false
      }

    },
    {
      path: '/x/AlignmentList',
      name: 'AlignmentList',
      component: AlignmentList,
      meta: {
        keepAlive: false
      }

    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/404',
      name: '404',
      component: NotFound
    },
    {
      path: '/',
      redirect: '/x/models'
    },
    {
      path: '*',
      redirect: '/404'
    }
    // {
    // path: '/about',
    // name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
});
